export function getFallbackGradeLabel(gradeCode) {
  const value = Number(gradeCode);
  if (Number.isNaN(value)) return String(gradeCode || 'Unnamed Grade');
  if (value === 0) return 'Kindergarten';
  if (value === -1) return 'Pre-K';
  if (value === -2) return 'Preschool';
  if (value === -3) return 'Pre-Preschool';

  const remainderTen = value % 10;
  const remainderHundred = value % 100;
  let suffix = 'th';

  if (remainderTen === 1 && remainderHundred !== 11) suffix = 'st';
  if (remainderTen === 2 && remainderHundred !== 12) suffix = 'nd';
  if (remainderTen === 3 && remainderHundred !== 13) suffix = 'rd';

  return `${value}${suffix} Grade`;
}
